import { SET_PROCESS_INSTANCE } from "../constants/actionTypes";

const initialState = {};

function processInstances(state = initialState, action) {
  switch (action.type) {
    case SET_PROCESS_INSTANCE:
      return {
        ...state,
        [action.chatId]: action.processInstance,
      };

    default:
      return state;
  }
}

export default processInstances;
